module.exports = __webpack_public_path__ + "static/media/success_premium_upgrade.07c6c57b.svg";